import React from 'react'

export default function Sidebar() {
  return (
    <aside className="bg-white w-1/4 fixed p-4 left-0 top-[75px] overflow-auto   h-full">
      <ul className=''>
        <li className="mb-3 text-sm text-gray-400 font-base">
          <span>Type</span>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">Sport <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">SUV <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">MPV <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">Sedan <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">Coupe <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">Hatchback <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li className="mt-4 mb-3 text-sm text-gray-400 font-base">
          <span>Capacity</span>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">2 Person <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">4 Person <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">6 Person <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
        <li>
          <div className="form-control">
            <label className="justify-start gap-2 cursor-pointer label">
              <input type="checkbox" className="w-5 h-5 border-blue-700 checkbox-primary checkbox" />
              <span className="text-sm font-medium text-[#596780] label-text">8 or More <span className='text-[#90A3BF]'>(10)</span></span>
            </label>
          </div>
        </li>
      </ul>
    </aside>
  )
}
